export default __webpack_public_path__ + "static/media/Logo_React.283f9f86.png";